import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtAZN } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BetControl } from "@/components/game/BetControl";
import { sfx } from "@/lib/sound";

export const BetPanel = ({ slot, s, m, mode, poll }) => {
  const { updateUser } = useAuth();
  const [amount, setAmount] = useState(1);
  const [autoOn, setAutoOn] = useState(false);
  const [auto, setAuto] = useState(2);
  const [busy, setBusy] = useState(false);
  const my = s?.my_bets.find((b) => b.slot === slot);
  const phase = s?.phase;

  const run = async (path, body, msg) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/aviator/${path}`, body);
      updateUser({ balance: data.balance, demo_balance: data.demo_balance });
      if (msg) { sfx.cashout(); toast.success(msg(data)); } else sfx.click();
      poll();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  let btn;
  if (phase === "betting" && !my) {
    btn = <button disabled={busy} onClick={() => run("bet", { amount, mode, slot, auto_cashout: autoOn ? auto : null })} className="w-full rounded-2xl py-4 font-display font-bold bg-emerald-500 hover:bg-emerald-400 text-black transition-colors disabled:opacity-60" data-testid={`aviator-bet-btn-${slot}`}>Mərc et<br /><span className="text-sm">{fmtAZN(amount)}</span></button>;
  } else if (phase === "flying" && my && my.cashed_at == null) {
    btn = <button disabled={busy} onClick={() => run("cashout", { bet_id: my.id }, (d) => `Götürüldü x${d.bet.cashed_at} · +${fmtAZN(d.bet.win)}`)} className="w-full rounded-2xl py-4 font-display font-bold bg-orange-500 hover:bg-orange-400 text-black transition-colors" data-testid={`aviator-cashout-btn-${slot}`}>Götür<br /><span className="text-sm">{fmtAZN(my.amount * m)}</span></button>;
  } else if (my?.cashed_at) {
    btn = <div className="w-full rounded-2xl py-4 text-center font-display font-bold bg-emerald-500/15 text-emerald-400 border border-emerald-500/40" data-testid={`aviator-won-${slot}`}>x{my.cashed_at} · +{fmtAZN(my.win)}</div>;
  } else if (phase === "betting" && my) {
    btn = <div className="w-full rounded-2xl py-4 px-2 text-center text-sm font-semibold whitespace-nowrap bg-[#D4AF37]/15 text-[#FFD700] border border-[#D4AF37]/40" data-testid={`aviator-waiting-${slot}`}>Mərc qəbul edildi · {fmtAZN(my.amount)}</div>;
  } else {
    btn = <div className="w-full rounded-2xl py-4 text-center text-sm text-zinc-500 bg-white/5 border border-white/10">{my?.lost ? "Uduzdunuz" : "Növbəti raundu gözləyin"}</div>;
  }

  const locked = !!my || phase !== "betting";
  return (
    <div className="rounded-2xl border border-white/10 bg-[#111]/90 backdrop-blur-xl p-4 grid sm:grid-cols-[1fr_170px] gap-4 items-center" data-testid={`aviator-panel-${slot}`}>
      <div className="space-y-3">
        <BetControl value={amount} onChange={setAmount} disabled={locked} testid={`aviator-bet-${slot}`} />
        <label className="flex items-center gap-3 text-sm text-zinc-400">
          <input type="checkbox" checked={autoOn} disabled={locked} onChange={(e) => setAutoOn(e.target.checked)} className="accent-[#D4AF37] w-4 h-4" data-testid={`aviator-auto-toggle-${slot}`} />
          Avto götür
          <input type="number" min="1.01" step="0.1" value={auto} disabled={!autoOn || locked} onChange={(e) => setAuto(Number(e.target.value))} className="jp-input !py-1.5 !w-24 text-center" data-testid={`aviator-auto-input-${slot}`} />
          <span>x</span>
        </label>
      </div>
      {btn}
    </div>
  );
};
